export enum Network {
  ROPSTEN = 'ropsten',
  MAINNET = 'mainnet'
}
